<template lang="html">
  <div>
    <vue-transmit
      tag="section"
      ref="uploader"
      v-bind="options"
      :id="'v-transmit'"
      upload-area-classes="bg-faded"
      :max-file-size="maxFileSize"
      :acceptedFileTypes="acceptedFileTypes"
      @added-file="handleAddedFile(arguments[0])"
      @error="handleError(arguments[0], arguments[1], arguments[2])"
      @success="handleSuccess(arguments[0], arguments[1], arguments[2])">
        <div id="banner-area" style="width: 100%; border: none; height: 300px">
          <div class="no-banner" v-if="!image.url && !processing">
            <h1>Arraste uma imagem ou clique em upload</h1>
            <h4>Tamanho da imagem: {{ width }}x{{ height }}</h4>
          </div>
          <!-- <div
          class="banner-image"
          v-if="image.url && !processing"
          :style="'background-image: url(' + image.url + ');  background-size: ' + backgroundSize + ';'">
          </div> -->
          <div class="media-preview" @click="triggerBrowse" :style="'background-image: url(' + image.url + ')'">
          </div>
          <div class="media-blur-preview" :style="'background-image: url(' + image.url + ')'">
          </div>
          <preloader :show="processing"></preloader>
        </div>
        <div class="col-lg-12">
          <div class="row mt-2">
            <div class="col-sm-8 alpha omega">
            </div>
            <div class="col-sm-4 pr-0">
              <button type="button" class="btn btn-outline-light text-info pull-right" @click="triggerBrowse">
                <i class="fa fa-upload"></i>
                Upload
              </button>
            </div>
          </div>
        </div>
    </vue-transmit>
  </div>
</template>
<script>
import { assign } from 'lodash'
export default {
  props: {
    transmitOptions: {
      type: Object,
      default () {
        return {
          withCredentials: false,
          clickable: false,
          maxConcurrentUploads: this.maxFiles || 30
        }
      }
    },

    method: {
      type: String,
      default: 'POST'
    },

    label: {
      type: String,
      default: 'Enviar arquivos'
    },

    url: {
      type: String,
      required: true
    },

    acceptedFileTypes: {
      type: Array,
      default: () => {
        return ['image/png', 'image/jpg', 'image/jpeg']
      }
    },

    maxFileSize: {
      type: Number,
      default: 200
    },

    isMultiple: {
      type: Boolean,
      default: false
    },

    image: {
      type: Object,
      default: {}
    },

    width: {
      type: Number,
      required: true
    },

    height: {
      type: Number,
      required: true
    },

    apiParams: {
      type: Object,
      default: {}
    }
  },

  computed: {
    options () {
      return assign(this.transmitOptions, {
        autoProcessQueue: false,
        url: this.url,
        method: this.method,
        params: this.apiParams
      })
    },

    backgroundSize () {
      return this.width >= 1920 ? 'cover' : 'contain'
    }
  },

  data () {
    return {
      processing: false
    }
  },

  methods: {
    handleAddedFile (file) {
      const self = this
      self.processing = true
      setTimeout(() => {
        const { width, height } = file
        if (self.width !== width || self.height !== height) {
          self.processing = false
          self.$toasted.error(`O arquivo enviado não possui o tamanho correto ${self.width}x${self.height}.`)
        } else {
          self.$refs.uploader.processFile(file)
        }
      }, 1000)
    },

    handleError (file, message, xhr) {
      this.processing = false
      if (message === "You can't upload files of this type.") {
        this.$refs.uploader.removeFile(file)
        this.$toasted.error('Você não pode fazer upload de arquivos desse tipo.')
      } else if (message.match('File is too big')) {
        this.$refs.uploader.removeFile(file)
        this.$toasted.error('O arquivo enviado é maior do que o limite estipulado.')
      } else if (message === 'You can not upload any more files.') {
        this.$refs.uploader.removeFile(file)
        this.$toasted.error('Você atingiu o limite de uploads!')
      } else if (xhr && xhr.status === 422) {
        this.$toasted.error('Ocorreu um erro ao realizar o upload do arquivo ' + file.name + '. Por favor, tente novamente.')
      } else {
        this.$toasted.error('Ocorreu um erro ao realizar o upload, por favor, tente novamente.')
      }
    },

    handleSuccess () {
      this.processing = false
      this.$emit('success', arguments[0], arguments[1], arguments[2])
    },

    showModal () {
      this.$refs.errorModal.show()
    },

    closeModal () {
      this.$refs.errorModal.hide()
    },

    triggerBrowse () {
      this.$refs.uploader.triggerBrowseFiles()
    }
  }
}
</script>
<style lang="scss" scoped>
  .banner-component-link {
    padding: 6px 0px;
    outline: none !important;
    color: #fff;
    text-shadow: 0px 1px 2px #000;
    font-weight: bold;
    /*********************/
    text-align: center;
    width: auto;
    float: none;
    min-width: 10px;
    border: 1px solid rgba(56, 60, 62, 0.68);
    text-align: center;
    background: rgba(56, 60, 62, 0.88);
    user-select: none;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s;

    &:focus {
      background: rgba(56, 60, 62, 0.68);
    }
  }

  input.error {
    border-color: #e66a81;
    box-shadow: 0 0 0 0.2rem rgba(234, 118, 118, 0.25);
  }

  .banner-modal-error {
    header {

      min-height: 90px;
      background: #F44336;
      color: #fff;
      flex-direction: column;
      text-align: center;
      font-size: 18px;

      .modal-title {
        width: 100%;
        text-align: center;
        font-size: 20px;
      }

      .modal-content {
        border: 1px solid rgba(40, 44, 55, 0.2);
        outline: 0;
        box-shadow: 0px 3px 7px rgba(44, 50, 63, 0.6);
      }

      &:before {
        content: '\F06A';
        font-family: 'fontAwesome';
        font-size: 50px;
        width: 100%;
        text-align: center;
        color: #b72114;
        opacity: 0.80;
      }
    }

    .close {
      position: absolute;
      top: 16px;
      right: 16px;
      padding: 9px;
      text-shadow: 0px 1px 1px #000;
    }
  }

  .no-banner {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(44, 50, 63, 0.96);
    text-shadow: 1px 2px 3px #000;
    color: #fff;
    font-size: 40px;
    padding-top: 80px;
    z-index: 999;
    text-align: center;
    text-transform: uppercase;
  }

  #banner-area{
    .container.grid {
      background: url('/static/img/grid.png') center left repeat-x;
    }
  }

  .provide-positon-center {
    position: absolute;
    text-transform: uppercase;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    h2 {
      font-size: 18px;
      font-weight: bolder;
      padding-top: 20px;
    }
  }

  .hidden {
    opacity: 0;
    visibility: hidden;
  }

  .h1-banner-title-span,
  .h3-banner-subtitle-span {
    opacity: 1;
    left: 0;
    width: 100%;
    padding: 0;
    font-size: 25px;
    padding-left: 15px;
    position: relative;
    font-weight: bold;
    padding-top: 2px;
    text-align: left;
    float: left;
  }

  .banner-title,
  .banner-subtitle {
    width: 100%;
    float: left;
    background: transparent;
    border: none;
    resize: none;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    min-height: 40px;
    padding-left: 15px;
  }

  .drag-your-image-here {
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    color: #fff;
    font-weight: bold;
    opacity: 0;
    visibility: hidden;
    transition: .4s ease-in-out;
    left: 0;
    background-image: url('/static/img/upload-image.png');
    background-position: center;
    background-size: 300px;
    background-repeat: no-repeat;
    z-index: 9999;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#606c88+0,3f4c6b+100&0.72+0,0.95+100;Grey+3D+%232 */
    background: -moz-radial-gradient(center, ellipse cover, rgba(96,108,136,0.72) 0%, rgba(63,76,107,0.95) 100%); /* FF3.6-15 */
    background: -webkit-radial-gradient(center, ellipse cover, rgba(96,108,136,0.72) 0%,rgba(63,76,107,0.95) 100%); /* Chrome10-25,Safari5.1-6 */
    background: radial-gradient(ellipse at center, rgba(96,108,136,0.72) 0%,rgba(63,76,107,0.95) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#b8606c88', endColorstr='#f23f4c6b',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */

  }
  .drag-image-here {

    .drag-your-image-here {
      opacity: 1;
      visibility: visible;
    }

    #banner-area {

      #ipt-file {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(101, 114, 132, 0.58);
        opacity: 0;
        visibility: visible;
        z-index: 999999;
      }
    }
  }

  .info-image {
    float: left;
    width: 100%;
    padding-top: 10px;
    color:#777070;

    label {
      font-size: 13px;
      &:first-child {
        padding-left: 0px;
        border-left: none;
      }
      &:last-child {
        border-right: none;
      }
      border-right: 1px solid rgba(228, 221, 221, 1);
      border-left: 1px solid rgba(212, 211, 211, 1);
      margin-right: -4px;
      display: inline-block;
      vertical-align: middle;
      padding-right: 8px;
      padding-left: 8px;
    }
  }

  #h1-banner-title,
  #h1-banner-subtitle {
    float: left;
    width: 100%;
    min-height: 40px;
    position: relative;
  }

  #banner-area {
    width: 100%;
    display: flex;
    height: 280px;
    overflow: hidden;
    position: relative;
    background-image: url('/static/img/upload-fig.png');
    border: 1px solid #d6d9da;

    .title, .subtitle {
      width: 100%;
      float: left;
      margin-top: 10px;
      height: 30px;
    }

    textarea {

      color: #fff;
      text-shadow: 0px 1px 2px #000;
      opacity: 1; /* Firefox */
      font-size: 25px;
      font-weight: bold;

      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: rgba(255, 255, 255, 0.52);
          text-shadow: 0px 1px 2px #000;
          opacity: 1; /* Firefox */
          font-size: 25px;
          font-weight: bold;
      }

      &:-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: rgba(255, 255, 255, 0.52);
      }

      &::-ms-input-placeholder { /* Microsoft Edge */
          color: rgba(255, 255, 255, 0.52);
      }
    }

    input {
      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: rgba(255, 255, 255, 0.52);
          text-shadow: 0px 1px 2px #000;
          opacity: 1; /* Firefox */
          font-size: 16px;
          font-weight: bold;
      }

      &:-ms-input-placeholder { /* Internet Explorer 10-11 */
          color: rgba(255, 255, 255, 0.52);
      }

      &::-ms-input-placeholder { /* Microsoft Edge */
          color: rgba(255, 255, 255, 0.52);
      }
    }

    .banner-image {
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: transparent;
      background-repeat:  no-repeat;
      background-position: center center;
      background-size: cover;
    }
    #ipt-file {
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0;
        visibility: hidden;
        cursor: pointer;
    }
  }

  .banner-text-in-the-middle {

    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;

  }

  .media-preview {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 9999 !important;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      -webkit-transition: background-image 0.2s ease-in-out;
      transition: background-image 0.2s ease-in-out;
    }

    .media-blur-preview {
      position: absolute;
      width: 100% !important;
      height: 100%;
      z-index: 0;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      filter: blur(80px);
      -webkit-transition: background-image 0.2s ease-in-out;
      transition: background-image 0.2s ease-in-out;
    }

  .list-group {
    .list-group-item {
      padding: 0.75rem 0;
    }
  }

  #v-transmit {
    cursor: pointer;
  }

  //Calendar
  div[type="button"] {
    -webkit-appearance: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/BannerComponent.vue